<ckeditor (change)="onchange($event)" [data]="data" [config]="config"></ckeditor>